export default __webpack_public_path__ + "static/media/PlusAddSvg.be04b71f.svg";